import { isObject, get } from 'lodash';

/**
 * A directive which will scan for a model, get its validation state and depending on it, add a `is-valid` or `is-invalid` CSS class
 */
const handleValidClass = function (el, binding) {
  el.classList.remove('is-valid');
  el.classList.remove('is-invalid');

  let value = binding.value;

  if (value === undefined) {
    let arg = binding.arg;
    if (Object.keys(binding.modifiers).length > 0) {
      const modifiers = Object.keys(binding.modifiers).join('.');
      arg += `.${modifiers}`;
    }
    value = get(binding.instance.v$, arg);
    if (!value) {
      throw new Error(`ValidClass directive: No validation associated with v-model's expression: ${value}`);
    }
  }

  if (isObject(value)) {
    const { $dirty, $error } = value;
    if ($dirty) {
      if ($error) {
        el.classList.add('is-invalid');
      } else {
        el.classList.add('is-valid');
      }
    }
  }

  if (value === true) {
    el.classList.add('is-valid');
  }

  if (value === false) {
    el.classList.add('is-invalid');
  }

  if (value == null) {
    // nothing to do
  }
};

export const validClass = {
  beforeMount: handleValidClass,
  updated: handleValidClass,
};
